var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReadMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3701 4.26876C12.0209 3.91567 11.452 3.91122 11.0973 4.25883L4.44483 10.8338L1.55292 7.83991C1.20801 7.48042 0.636985 7.46862 0.277533 7.81354C-0.0819574 8.15846 -0.0937568 8.72948 0.251161 9.08893C0.252723 9.09053 0.254247 9.09213 0.25581 9.09373L3.78188 12.7479C3.95062 12.92 4.18126 13.0175 4.42233 13.0185H4.43225C4.66875 13.0177 4.89551 12.9241 5.06367 12.7578L12.362 5.54153C12.7146 5.19185 12.7182 4.62294 12.3701 4.26876Z",
    fill: "#0075EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19407 12.7479C9.36239 12.9196 9.59228 13.017 9.83272 13.0185H9.84265C10.0791 13.0177 10.3059 12.9241 10.4741 12.7578L17.7724 5.54153C18.1032 5.16903 18.0694 4.59891 17.697 4.26809C17.3593 3.96818 16.8519 3.96424 16.5096 4.25883L9.85976 10.8338L9.62252 10.5875C9.27764 10.228 8.70662 10.2162 8.34713 10.5611C7.98764 10.906 7.9758 11.477 8.32072 11.8365C8.32228 11.8381 8.32385 11.8397 8.32541 11.8413L9.19407 12.7479Z",
    fill: "#0075EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadMessage);
export default __webpack_public_path__ + "static/media/read-message.b58b32d447281fb9d367de7bf6c70be4.svg";
export { ForwardRef as ReactComponent };